<script setup>
import { useSettingsStore } from '@/stores/settings';

const settingsStore = useSettingsStore();
const settings = settingsStore.settings;
const route = useRoute();
let sportsBookType = settings.sport_sportbook_type;

// Validate regulation parameter
if (!["betting-terms", "funds-and-transactions-policy", "about", "aml", "terms-and-conditions", "responsible-gaming", "privacy-policy", "cookies-policy", "pld-ft-policy", "rules", "suport", "affiliates", "funds", "faq", "affiliates"].includes(route.params.regulation)) {
    await navigateTo({
        path: '/',
        query: route.query
    });
    
}

// Fetch regulation data server-side for SEO
const { data: regulationData, error } = await useFetch('/api/regulation', {
    key: `regulation-${route.params.regulation}`,
    server: true,
    default: () => ({})
});

// Handle error - throw immediately if API fails
if (error.value || !regulationData.value) {
    throw createError({
        statusCode: 500,
        statusMessage: 'Falha ao carregar a pagina'
    });
}

// Extract the specific regulation content
const current = computed(() => {
    if (!regulationData.value) return null;
    return regulationData.value[route.params.regulation] || null;
});

// Set up SEO meta tags
useHead(() => ({
    title: current.value?.title || `${route.params.regulation.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}`,
    meta: [
        {
            name: 'description',
            content: current.value?.text ? current.value.text.replace(/<[^>]*>/g, '').substring(0, 160) + '...' : 'Regulation information'
        },
        {
            name: 'robots',
            content: 'index, follow'
        }
    ]
}));

// Handle loading state
const isLoading = computed(() => !regulationData.value);

</script>

<template>
    <div v-if="isLoading">
        <p>Carregando...</p>
    </div>
    <div v-else>
        <p class="text-end" v-if="route.params.regulation === 'rules'">
            <code class="text-sm">
                 Versão do software de apostas: {{ sportsBookType === 'altenar' ? '2.0' : '1.0' }}
             </code>
        </p>
        <div v-if="current && current.text" v-html="current.text" class="p-5">
        </div>
    </div>
</template>
